import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { MOBILE_THRESHOLD } from '../../core/constants';
import { Flex, FlexCentered } from '~/components/basic/containers';

const ButtonContainer = styled(Flex)`
  width: 100%;
  height: 40px;
  margin: 0 auto 8px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 15px;
  position: relative;
  cursor: ${({ disabled }) => !disabled ? 'pointer' : 'default'};
  background-color: ${({ backgroundColor, disabled, theme }) => {
    if (disabled) {
      return theme.disabled;
    }

    return backgroundColor ?? 'none';
  }};
  color: ${({ theme }) => theme.lightFont};

  &:hover {
    background-color: ${({ backgroundColorHover, disabled, theme }) => {
    if (disabled) {
      return theme.disabled;
    }

    return backgroundColorHover ?? 'none';
  }};
  }

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    height: 48px;
    margin: 0 auto 16px;
  }
`;

const TextContainer = styled.div`
  margin: auto;
`;

const IconContainer = styled(FlexCentered)`
  position: absolute;
  left: 8px;

  @media screen and (max-width: ${MOBILE_THRESHOLD}px) {
    left: 12px;
  }
`;

const Button = ({
  backgroundColor,
  backgroundColorHover,
  Icon,
  text,
  callback,
  disabled,
  iconColor,
}) => (
  <ButtonContainer
    backgroundColorHover={ backgroundColorHover }
    backgroundColor={ backgroundColor }
    disabled={ disabled }
    onClick={ () => !disabled && callback() }
  >
    <IconContainer fullHeight>
      { Icon && <Icon color={ iconColor } /> }
    </IconContainer>
    <TextContainer>{ text }</TextContainer>
  </ButtonContainer>
);

Button.propTypes = {
  backgroundColor: PropTypes.string,
  backgroundColorHover: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
  text: PropTypes.string,
  callback: PropTypes.func,
  disabled: PropTypes.bool,
  iconColor: PropTypes.string,
}

Button.defaultProps = {
  disabled: false,
  iconColor: '#FFF',
  backgroundColorHover: '#5285ED',
};


export default Button;